import { useParams } from 'react-router-dom';

import { AppRoute } from './AppRoute';

export function useAppRouteParams<
  T extends AppRoute<string, string, string, string, string>,
>(
  _routePath: T, // eslint-disable-line @typescript-eslint/no-unused-vars
) {
  return useParams() as Record<
    T['groupParams'][number] | T['relativeParams'][number],
    string
  >;
}
